Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
{ getKey, Key } = require '@trello/keybindings'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'app/scripts/views/card/card-limits-error'
LabelLimitsErrorView = require 'app/scripts/views/label/label-limits-error-view'
SelectCardPosition = require 'app/scripts/views/card/select-card-position'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
parseURL = require 'url-parse'
f = require 'effing'
_ = require 'underscore'

module.exports = mixin SelectCardPosition, class CardCopyView extends View
  viewTitleKey: 'copy card'

  initialize: (opts) ->
    @onCopy = opts.onCopy ? (->)

  showCurrentPosition: true

  events:
    'change .js-select-position': 'renderValues'
    'change .js-select-list': 'updatePositionList'
    'change .js-select-board': 'updateBoardData'

    'keydown textarea[name="name"]': 'keydownEvent'
    'click .js-submit': 'submit'
    'submit form': 'submit'

  render: ->
    data = @model.toJSON()
    data.numChecklists = @model.checklistList.length
    data.numMembers = data.idMembers.length
    data.numLabels = data.idLabels?.length ? 0
    data.numAttachments = data.badges.attachments
    data.numComments = data.badges.comments
    data.numStickers = data.stickers.length

    data.hasChecklists = data.numChecklists > 0
    data.hasMembers = data.idMembers.length > 0
    data.hasLabels = data.numLabels > 0
    data.hasAttachments = data.badges.attachments > 0
    data.hasComments = data.badges.comments > 0
    data.hasStickers = data.stickers.length > 0

    data.hasStuff = (data.numChecklists + data.idMembers.length + data.numLabels + data.badges.attachments + data.badges.comments + data.stickers.length) > 0

    data.loading = @loading

    currentBoard = @model.getBoard()
    enterprise = @model.getBoard().getEnterprise()
    showFeature = featureFlagClient.get('enterprise.restrict-moves-and-copies-into-teams-within-enterprise', false)
    if enterprise? && showFeature
      data.isCopy = true
      data.hasEnterprise = enterprise?
      data.organizations = Auth.me().getOpenBoardsInEnterpriseByOrg(true, enterprise.get('id'))
      data.enterpriseName = enterprise.get('displayName')
    else
      currentBoard = if @model.getBoard().isEditableByTeamMemberAndIsNotABoardMember() then currentBoard else null
      data.organizations = Auth.me().getOpenBoardsByOrg(true, currentBoard)

    for org in data.organizations
      for board in org.boards
        if board.id == @model.get('idBoard')
          board.selected = true

    partials =
      'move_card_controls': templates.move_card_controls

    @$el.html(
      templates.fill(
        'card_copy',
        data,
        { editable: @model.editable() },
        partials
      )
    )

    @updateBoardData()

    @

  getData: ->
    @loading = true

    ModelLoader.loadCardCopyData @model.get('idBoard'), @model.id
    .finally =>
      @loading = false
      @render()
    .done()

  keydownEvent: (e) ->
    if getKey(e) == Key.Enter
      Util.stop(e)
      @submit(e)
      return

  submit: (e) ->
    Util.stop(e)

    nameInput = @$('textarea[name="name"]')

    # return if the user hasn't entered a title
    if nameInput.val().trim() == ''
      nameInput.focus().select()
      return

    idListSelected = @$('.js-select-list').find('option:selected').val()
    idBoardSelected = @$('.js-select-board').find('option:selected').val()
    boardSelected = @modelCache.get('Board', idBoardSelected)
    listSelected = boardSelected?.listList.get(idListSelected)
    options = {
      $elem: @$(e.target),
      hasChecklists: @model.checklistList.length > 0,
      hasAttachments: @model.attachmentList.length > 0,
      destinationBoard: boardSelected,
      destinationList: listSelected,
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    mandatoryFieldsToKeep = ['due']
    optionalFieldsToKeep = @$('input:checkbox:checked').get().map f.get('name')
    fieldsToKeep = mandatoryFieldsToKeep.concat(optionalFieldsToKeep)

    if idBoardSelected != @model.getBoard().id
      hasLabels = @model.getLabels().length > 0 && _.contains(fieldsToKeep,
        "labels"
      )
      if hasLabels && boardSelected.isOverLimit('labels', 'perBoard')
        PopOver.pushView(new LabelLimitsErrorView())
        return

    # prevent card copy spamming
    # currently, if the card-copy request fails, the modal dialog closes anyway
    # (we don’t have error handling here), so there is no need to re-enable it.
    @$('.js-submit').attr('disabled', 'disabled')

    @model.copyTo
      name: nameInput.val().trim()
      idList: idListSelected
      pos: @$('.js-select-position').find('option:selected').val()
      keepFromSource: fieldsToKeep
    .then =>
      PopOver.hide()
      @onCopy()
      track("Card", "Copy Card")

    return
